import React, { FC } from "react";
import { TableBody as MuiTableBody, TableBodyProps } from "@mui/material";

const TableBody: FC<TableBodyProps> = (props) => <MuiTableBody {...props} />;

export default TableBody;
